import $ from "jquery/dist/jquery";
import "../../scss/static/02_fuckeu.scss";

$(() => {
  if (!window.NXCMS?.modal) {
    window.alert(
      "Support library is not loaded (like BS3/BS5). Import it in your main JS file."
    );
  }
});
